import { render, staticRenderFns } from "./TechnicalDay.vue?vue&type=template&id=ec2a28de"
import script from "./TechnicalDay.vue?vue&type=script&lang=js"
export * from "./TechnicalDay.vue?vue&type=script&lang=js"
import style0 from "./TechnicalDay.vue?vue&type=style&index=0&id=ec2a28de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports